// Cette fonction permet de gérer le tableau contenant les années pour qu'elle supprime les années inférieures à celle sélectionnée au début du parcours
export const filterYears = (allYears, selectedYear) => {
    const tableauFiltre = allYears.filter((year) => year >= selectedYear);
    return tableauFiltre;
}